import React from 'react'
import "@fontsource/carattere"; // Import the Carattere font
import "@fontsource/carattere/400.css"; // Import specific weight
import "@fontsource/roboto-condensed"; // Import Roboto Condensed font
import "@fontsource/roboto-condensed/400.css"; // Import normal weight
import "@fontsource/roboto-condensed/500.css"; // Import medium weight

import Dashbord from '../userdashbord/DetaliesDashbord'
import Header from '../Header';
import Dropdown from './Dropdown';
import AllProfiledetalies from './AllProfiledetalies';
import { Box } from '@mui/material';
import Footer from '../Footer'
const dashbordcommonroutes = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#fdf1e0" }}>
        <Header />
        <Dashbord />
        <Dropdown />
        <AllProfiledetalies />
        <Footer />
        
      </Box>
    </>
  )
}

export default dashbordcommonroutes